import axios from 'axios';
import Cookies from 'js-cookie';

const instance = axios.create({
	baseURL: `${process.env.REACT_APP_BASE_URL}/api/v1`,
	timeout: 20000,
	withCredentials: true,
});

instance.defaults.headers.common['Content-Type'] = 'application/json';

// instance.defaults.headers.post['Content-Type'] = 'multipart/form-data';

async function handleResponseError(error) {
	const { response, message, request } = error;

	const errorMessage = response?.data?.message || message || request || 'Unknown error';

	console.log('Axios error:', errorMessage);

	return Promise.reject(errorMessage);
}

// Do something before request is sent

instance.interceptors.request.use(
	(config) => {
		console.log('🚀 ~ file: baseApi.js:26 ~ config:', config);
		const accessToken = Cookies.get('_auth');

		config.headers.Authorization = `Bearer ${accessToken}`;

		return config;
	},
	(error) => {
		// Do something with request error
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString() ||
			error.request;

		console.log('🚀 ~ file: baseApi.js:22 ~ message:', message);

		return Promise.reject(message);
	}
);

// Add a response interceptor
instance.interceptors.response.use((response) => {
	return response;
}, handleResponseError);

export default instance;
